/*
 * Copyright 2018 Experian. All Rights Reserved
 */

import {Injectable} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class Globals {

  private authorized: boolean;
  private showLoadingSubject: BehaviorSubject<Array<string>> = new BehaviorSubject<Array<string>>([]);
  public showLoading = this.showLoadingSubject.asObservable();

  constructor(private snackBar: MatSnackBar ) { }

  showSnackBar(message: string, cssClasses: string[] = ["snackbar-error"], duration = 3000 ): void{
    this.snackBar.open(message, 'OK',{
      duration: duration,
      panelClass: cssClasses,
    });
  }

  addToLoading(itemToAdd: string): void {
    const currentValue = this.showLoadingSubject.value;
    const updatedValue = [...currentValue, itemToAdd];
    this.showLoadingSubject.next(updatedValue);
  }

  subtractFromLoading(): void {
    if (this.showLoadingSubject.value && this.showLoadingSubject.value.length) {
      const currentValue = this.showLoadingSubject.value;
      currentValue.splice(-1);
      this.showLoadingSubject.next(currentValue);
    }
  }

  setAuthorized(authorized: boolean) {
    this.authorized = authorized;
  }

  getAuthorized(): boolean {
    return this.authorized;
  }
}
